import customerCentricImage from "../../assets/images/blogs/customer-centric-mindset-the-catalyst-for-enhancing-customer-lifetime-value.jpg";
import LeveragingImage from "../../assets/images/blogs/Data-Storytelling-1.webp";
import lightingTheWay from "../../assets/images/blogs/lightling.webp";
import winBackLostCustomers from "../../assets/images/blogs/win-back-lost-customers.webp";
import generateMarketingStrategiesImage from "../../assets/images/blogs/generational-marketing.webp";
import frictionlessOrMemorablecx from "../../assets/images/blogs/frictionless-or-memorable-cx.webp";
import makeRepeatPurchasesANewCustomerHabit from "../../assets/images/blogs/repeat-purchase-habit.webp";
import RevitalizeYourCustomerBase from "../../assets/images/blogs/RevitalizeYourCustomerBase.webp";
import TheDiverseHatsWornbyMarTechProfessionals from "../../assets/images/blogs/The-Diverse-Hats-Worn-byMarTech-Professionals.webp";
import orthogonalStrategies from "../../assets/images/blogs/orthogonal-strategies.webp";
import FutureProofing from "../../assets/images/blogs/Linkedin-ad-creatives-2.webp";
import LostCustomers from "../../assets/images/blogs/lost-customers.png";
import CraftingMagneticConnections from "../../assets/images/blogs/Linkedin-ad-creatives-1.webp";
import PowerBI from "../../assets/images/blogs/Linkedin-ad-creatives.webp";
import GenAI from "../../assets/images/blogs/genai.webp";
import BehavioralAnalytics from "../../assets/images/blogs/behavior-analytics.webp";
import marketingChaosMin from "../../assets/images/blogs/marketing-chaos-min.webp";
import WebsiteVisitors from "../../assets/images/blogs/Reading-between-clicks.webp";
import decoyPicMin from "../../assets/images/blogs/decoy-pic-min.webp";
import ExtractingWisdom from "../../assets/images/blogs/Extracting-Wisdom.webp";
import digitalTwins from "../../assets/images/blogs/digital-twins.webp";
import Ecommerence from "../../assets/images/blogs/e-commerence.webp";
import KPILibrary from "../../assets/images/blogs/KPI-library.webp";
import customerSignals from "../../assets/images/blogs/customer-signals.webp";
import IDENTITYRESOLUTION from "../../assets/images/blogs/IDENTITY-RESOLUTION.webp";
import DigitalAlchemyMin from "../../assets/images/blogs/Digital-Alchemy-min.webp";
import SecretsToDeliveringAnImmersiveCustomerExperience from "../../assets/images/blogs/Secrets-to-Delivering-an-Immersive-Customer-Experience.webp";
import InTheMomentExperience from "../../assets/images/blogs/In-the-moment-Experience-in-Phygital-World.webp";
import GameChangingInnovationsInRetailCX from "../../assets/images/blogs/retial-CX.webp";
import WhyConsolidating from "../../assets/images/blogs/Why-Consolidating-Traditional-Digital-Commerce-is-Crucial-to-Omnichannel-Agility-and-Viability-for-Marketers.webp";
import TopHacksToHookCustomers from "../../assets/images/blogs/Top-Hacks-To-Hook-customers.webp";
import SustainingParadox from "../../assets/images/blogs/Sustaining-Paradox.webp";
import mtech from "../../assets/images/blogs/mtech.webp";
import emailMarketing from "../../assets/images/blogs/email-marketing.webp";
import CookielessWorld from "../../assets/images/blogs/Cookieless-world.webp";
import IntegratedExperience from "../../assets/images/blogs/Integrated-Experience-2.webp";
import bi from "../../assets/images/blogs/bi.webp";
import BiggestDataScienceChallenges from "../../assets/images/blogs/Biggest-Data-Science-Challenges-of-2023-and-How-to-Overcome-Them.png";
import datadocument from "../../assets/images/blogs/data-document.webp";
import shooIndustries from "../../assets/images/blogs/shoo-industries.webp";
import BIDashboardDesignPrinciples from "../../assets/images/blogs/BI-Dashboard-Design-Principles.webp";
import EcommerceBusinessWithDataEngineering from "../../assets/images/blogs/E-commerce-Business-with-Data-Engineering.webp";
import DigitalEcosystems from "../../assets/images/blogs/digital-ecosystem.webp";
import MicrosoftTeams from "../../assets/images/blogs/MicrosoftTeams-image-14-1-1.webp";
import machinLearning from "../../assets/images/blogs/machin-learning.webp";
import tanviBlog from "../../assets/images/blogs/tanvi-blog-2-2.webp";
import marketingAutomation from "../../assets/images/blogs/marketing-automation.webp";
import SagarBlog from "../../assets/images/blogs/Sagar-Blog-1-1.webp";
import PredictiveAnalytics from "../../assets/images/blogs/Predictive-Analytics.webp";
import PredictiveAnalytics2 from "../../assets/images/blogs/Predictive-Analytics-2.webp";
import DataAnalysis from "../../assets/images/blogs/Data-Analysis.webp";
import BlogCaree from "../../assets/images/blogs/Blog-Caree-1.webp";
import marketingAndCustomer from "../../assets/images/blogs/marketing-and-customer.webp";
import BlogCareers from "../../assets/images/blogs/BlogCareers.webp";
import VineetPhoto from "../../assets/images/blogs/Vineet-photo-1.webp";
import empCollage from "../../assets/images/blogs/emp-collage-1.webp";
import AICopilotsImg from "../../assets/images/blogs/AI-Copilot.jpeg";
import thinkcraftImg from "../../assets/images/blogs/Thinkcraft.jpg";
import salesforceImg from "../../assets/images/blogs/Salesforce.jpeg";
import salesforceAgentforceImg from "../../assets/images/blogs/salesforce_agentforce.jpeg";
import salesforceMarketingCloudImg from "../../assets/images/blogs/salesforce-marketing-cloud.jpeg";
import HeadlessCRMImg from "../../assets/images/blogs/Headless-CRM.png";
import slackImg from "../../assets/images/blogs/slack.png";
import gccImg from "../../assets/images/blogs/gcc.png";
import WhyTheNextGCCWillBeJudgedOnValueNotJustCostImg from "../../assets/images/blogs/Why-the-Next-GCC-Will-Be-Judged-on-Value-Not-Just-Cost.jpg";
import B2BCustomerDataPlatformBestPracticesImg from "../../assets/images/blogs/B2B-Customer-Data-Platform-Best-Practices.jpg";
import SalesforceMarketingCloudMigrationServicesImg from "../../assets/images/blogs/Salesforce-Marketing-Cloud-Migration-Services-What-Businesses-Need-to-Know-Before-Making-the-Switch.jpg";
import WhyRetailersAreRethinkingCustomerExperienceInTheAiEraImg from "../../assets/images/blogs/Why-Retailers-Are-Rethinking-Customer-Experience-in-the-AI-Era.jpg";
import HowComsenseCombatsSalesforceMarketingCloudMigrationChallengesImg from "../../assets/images/blogs/How-Comsense-Combats-Key-Challenges-That-Businesses-Face-During-Salesforce-Marketing-Cloud-Migration.jpg";
import ThePersonalizationPlaybookIsChangingImg from "../../assets/images/blogs/The-Personalization-Playbook-Is-Changing.jpg";
import HowToMaximizeSalesforceMarketingCloudRoiImg from "../../assets/images/blogs/How-to-Maximize-Salesforce-Marketing-Cloud-ROI.jpg";

export const blogs = [
{
id: 70,
title: "How to Maximize Salesforce Marketing Cloud ROI",
    category: "Blogs",
    date: "",
    author: "Comsense Technologies",
    excerpt:
      "",
    image: HowToMaximizeSalesforceMarketingCloudRoiImg,
    slug: "how-to-maximize-salesforce-marketing-cloud-roi",
    metaTitle: "How to Maximize Salesforce Marketing Cloud ROI",
    metaDescription:
      "Not seeing the results you expected from Salesforce Marketing Cloud? Learn how better data quality, smarter segmentation, optimized journeys, automation, and outcome-based metrics can maximize ROI.",
    metaKeywords:
      "Salesforce Marketing Cloud ROI, Marketing Cloud optimization, customer journey optimization, marketing automation, customer segmentation",
},
{
id: 69,
title: "The Personalization Playbook Is Changing. Is Your Business Ready?",
    category: "Blogs",
    date: "",
    author: "Comsense Technologies",
    excerpt:
      "",
    image: ThePersonalizationPlaybookIsChangingImg,
    slug: "the-personalization-playbook-is-changing-is-your-business-ready",
    metaTitle: "The Personalization Playbook Is Changing. Is Your Business Ready?",
    metaDescription:
      "Rule-based personalization can no longer keep up with customer expectations. Learn how AI, predictive recommendations, real-time decisioning, and unified customer intelligence are reshaping personalization.",
    metaKeywords:
      "AI personalization, AI personalization platform, predictive customer intelligence, real-time decisioning, customer intelligence, marketing personalization",
},
{
id: 68,
title: "How Comsense Combats Key Challenges That Businesses Face During Salesforce Marketing Cloud Migration",
    category: "Blogs",
    date: "",
    author: "Comsense Technologies",
    excerpt:
      "",
    image: HowComsenseCombatsSalesforceMarketingCloudMigrationChallengesImg,
    slug: "how-comsense-combats-key-challenges-that-businesses-face-during-salesforce-marketing-cloud-migration",
    metaTitle: "How Comsense Combats Key Challenges That Businesses Face During Salesforce Marketing Cloud Migration",
    metaDescription:
      "Data quality, legacy workflows, integrations, campaign disruption, and user adoption can derail a Salesforce Marketing Cloud migration. Learn how Comsense helps businesses overcome them.",
    metaKeywords:
      "Salesforce Marketing Cloud migration, Marketing Cloud migration challenges, data migration, marketing automation migration, Salesforce consulting",
},
{
id: 67,
title: "Why Retailers Are Rethinking Customer Experience in the AI Era",
    category: "Blogs",
    date: "",
    author: "Comsense Technologies",
    excerpt:
      "",
    image: WhyRetailersAreRethinkingCustomerExperienceInTheAiEraImg,
    slug: "why-retailers-are-rethinking-customer-experience-in-the-ai-era",
    metaTitle: "Why Retailers Are Rethinking Customer Experience in the AI Era",
    metaDescription:
      "AI is transforming retail customer experience. Learn how unified customer data, personalization, smarter inventory, and intelligent support are redefining retail AI transformation.",
    metaKeywords:
      "retail AI transformation, retail customer experience, AI personalization, unified customer data, AI in retail",
},
{
id: 66,
title: "Salesforce Marketing Cloud Migration Services: What Businesses Need to Know Before Making the Switch",
    category: "Blogs",
    date: "",
    author: "Comsense Technologies",
    excerpt:
      "",
    image: SalesforceMarketingCloudMigrationServicesImg,
    slug: "salesforce-marketing-cloud-migration-services-what-businesses-need-to-know-before-making-the-switch",
    metaTitle: "Salesforce Marketing Cloud Migration Services: What Businesses Need to Know Before Making the Switch",
    metaDescription:
      "Migrating to Salesforce Marketing Cloud from HubSpot, Marketo, Mailchimp, Adobe, or Eloqua? Learn why businesses migrate, what the process involves, and how to plan a successful transition.",
    metaKeywords:
      "Salesforce Marketing Cloud migration, marketing automation migration, Salesforce Marketing Cloud services, customer data migration, marketing cloud implementation",
},
{
id: 65,
title: "B2B Customer Data Platform Best Practices: Build Smarter Customer Experiences",
    category: "Blogs",
    date: "",
    author: "Comsense Technologies",
    excerpt:
      "",
    image: B2BCustomerDataPlatformBestPracticesImg,
    slug: "b2b-customer-data-platform-best-practices",
    metaTitle: "B2B Customer Data Platform Best Practices: Build Smarter Customer Experiences",
    metaDescription:
      "Learn the best practices for building a B2B Customer Data Platform strategy, from unifying customer data and improving data quality to activating insights across teams and preparing for AI.",
    metaKeywords:
      "B2B customer data platform, CDP best practices, unified customer data, account-based marketing, customer data quality",
},
{
id: 64,
title: "Why the Next GCC Will Be Judged on Value, Not Just Cost",
    category: "Blogs",
    date: "",
    author: "Comsense Technologies",
    excerpt:
      "",
    image: WhyTheNextGCCWillBeJudgedOnValueNotJustCostImg,
    slug: "why-the-next-gcc-will-be-judged-on-value-not-just-cost",
    metaTitle: "Why the Next GCC Will Be Judged on Value, Not Just Cost",
    metaDescription:
      "GCCs are evolving from cost centers into strategic value centers. Learn how innovation, AI readiness, and talent are redefining how Global Capability Centers are measured.",
    metaKeywords:
      "Global Capability Centers, GCC transformation, GCC value creation, AI-ready enterprises, GCC talent strategy",
},
{
id: 63,
title: "Global Capability Centers Need a Reset — Here’s Why We’re Building Them Differently",
    category: "Blogs",
    date: "",
    author: "Sagar Babar",
    excerpt: "",
    image: gccImg,
    slug: "global-capability-centers-need-a-reset",
    metaTitle: "Global Capability Centers Need a Reset — Here’s Why We’re Building Them Differently",
},
  {
id: 62,
title: "How Comsense Helps Teams Get More Value from Slack",
    category: "Blogs",
    date: "",
    author: "Vijay Pujari",
    excerpt: "",
    image: slackImg,
    slug: "how-comsense-helps-teams-get-more-value-from-slack",
    metaTitle: "How Comsense Helps Teams Get More Value from Slack",
    metaDescription: "Discover how Comsense integrates Slack with Salesforce to improve collaboration, faster decision-making, and team productivity.",
    metaKeywords: "Comsense Slack integration, Salesforce Slack integration, Slack collaboration tools, Salesforce workflow automation, AI in Slack, Salesforce productivity, Slack CRM integration, Comsense Technologies,",
},
  {
    id: 61,
    title: "Headless CRM: The Foundation for Agentic Enterprises",
    category: "Blogs",
    date: "",
    author: "Wasim Miya",
    excerpt: "",
    image: HeadlessCRMImg,
    slug: "headless-crm",
  },
  {
    id: 60,
    title: "Turning Customer Engagement into Measurable Growth with Salesforce Marketing Cloud",
    category: "Blogs",
    date: "",
    author: "Neha Kushwaha",
    excerpt: "",
    image: salesforceMarketingCloudImg,
    slug: "salesforce-marketing-cloud",
  },
  {
    id: 59,
    title: "Salesforce Agentforce in Action: High-Value AI Use Cases That Deliver",
    category: "Blogs",
    date: "",
    author: "Vijay Pujari",
    excerpt: "",
    image: salesforceAgentforceImg,
    slug: "salesforce-agentforce-use-cases",
  },
  {
    id: 58,
    title: "Salesforce Implementation Services in India",
    category: "Blogs",
    date: "",
    author: "Shivkumar Dusad",
    excerpt: "",
    image: salesforceImg,
    slug: "salesforce-implementation-services-in-india",
  },
  {
    id: 56,
    title:
      "How Retail CMOs Can Overcome Their Biggest Challenges with AI Copilots",
    category: "Blogs",
    date: "",
    author: "Omkar Dhapte",
    excerpt: "",
    image: AICopilotsImg,
    slug: "how-retail-cmos-can-overcome-their-biggest-challenges-with-ai-copilots",
  },
  {
    id: 57,
    title: "Build Applications 3x Faster with AI-Powered Project Intelligence",
    category: "Blogs",
    date: "",
    author: "Omkar Dhapte",
    excerpt: "",
    image: thinkcraftImg,
    slug: "build-applications-3x-faster-with-ai-powered-project-intelligence",
  },
  // {
  //   id: 58,
  //   title:
  //     "Too Many Tools, Too Little Impact: Why Martech Fails (and How to Win in 2026)",
  //   category: "Blogs",
  //   date: "",
  //   author: "Comsense Tech",
  //   excerpt: "",
  //   image: fusion360Img,
  //   slug: "why-martech-fails-and-how-to-win-2026",
  // },
  {
    id: 1,
    title:
      "Customer-Centric Mindset: The Catalyst for Enhancing Customer Lifetime Value",
    category: "Blogs",
    date: "",
    author: "Biju Nambiar",
    excerpt: "",
    image: customerCentricImage,
    slug: "customer-centric-mindset-the-catalyst-for-enhancing-customer-lifetime-value",
  },
  {
    id: 2,
    title: "Leveraging Data Storytelling to Drive Customer Engagement",
    category: "Analytics",
    date: "",
    author: "Vishnu Kamath",
    excerpt: "",
    image: LeveragingImage,
    slug: "data-storytelling",
  },
  {
    id: 3,
    title: "Lighting the Way with Marketing KPI Beacons",
    category: "Analytics",
    date: "",
    author: "Shruti Mishra",
    excerpt: "",
    image: lightingTheWay,
    slug: "lighting-the-way-with-marketing-kpi-beacons",
  },
  {
    id: 4,
    title: "Win Back Lost Customers with our Proven Tactics",
    category: "Blogs",
    date: "",
    author: "Neha Kushwaha",
    excerpt: "",
    image: winBackLostCustomers,
    slug: "win-back-lost-customers",
  },
  {
    id: 5,
    title: "Marketing Strategies that Resonate with Every Generation",
    category: "Blogs",
    date: "",
    author: "Biju Nambiar",
    excerpt: "",
    image: generateMarketingStrategiesImage,
    slug: "generational-marketing-strategies",
  },
  {
    id: 6,
    title:
      "Should Your Brand Glide Through or Leave a Lasting Mark with Customer Experience?",
    category: "Blogs",
    date: "",
    author: "Neeraj Gogavale",
    excerpt: "",
    image: frictionlessOrMemorablecx,
    slug: "frictionless-or-memorable-cx",
  },
  {
    id: 7,
    title: "Make Repeat Purchases a New Customer Habit",
    category: "BI & Analytics",
    date: "",
    author: "Umang Varshney",
    excerpt: "",
    image: makeRepeatPurchasesANewCustomerHabit,
    slug: "make-repeat-purchases-a-new-customer-habit",
  },
  {
    id: 8,
    title: "Revitalize Your Customer Base",
    category: "Analytics",
    date: "",
    author: "Karan Mudliar",
    excerpt: "",
    image: RevitalizeYourCustomerBase,
    slug: "revitalize-your-customer-base",
  },
  {
    id: 9,
    title: "The Diverse Hats Worn by MarTech Professionals",
    category: "Blogs",
    date: "",
    author: "Vaishnavi Patki",
    excerpt: "",
    image: TheDiverseHatsWornbyMarTechProfessionals,
    slug: "martech-professionals",
  },
  {
    id: 10,
    title: "Exploring the Power of Orthogonal Strategies in MarTech",
    category: "Blogs",
    date: "",
    author: "Vrushali Paralkar",
    excerpt: "",
    image: orthogonalStrategies,
    slug: "orthogonal-strategies",
  },
  {
    id: 11,
    title: "Future-Proofing Your Marketing Strategy",
    category: "Blogs",
    date: "",
    author: "Abhishek Deshpande",
    excerpt: "",
    image: FutureProofing,
    slug: "future-proofing-marketing-strategy",
  },
  {
    id: 12,
    title: "A Blueprint for Winning Back Lost Customers",
    category: "Blogs",
    date: "",
    author: "Sonali Irani",
    excerpt: "",
    image: LostCustomers,
    slug: "winning-back-lost-customers",
  },
  {
    id: 13,
    title: "Crafting Magnetic Connections with Your Most Valued Clients",
    category: "Analytics",
    date: "",
    author: "Sushant Pingle",
    excerpt: "",
    image: CraftingMagneticConnections,
    slug: "crafting-magnetic-connections",
  },
  {
    id: 14,
    title: "How Power BI is Reshaping the Shopping Experience",
    category: "BI & Analytics",
    date: "",
    author: "Shreepad Bidwai",
    excerpt: "",
    image: PowerBI,
    slug: "power-bi-retail",
  },
  {
    id: 15,
    title: "Seize the Future with GenAI",
    category: "Blogs",
    date: "",
    author: "Sushil Gujrathi",
    excerpt: "",
    image: GenAI,
    slug: "seize-the-future-genai",
  },
  {
    id: 16,
    title: "Mastering Business Dynamics with Behavioral Analytics",
    category: "Analytics",
    date: "",
    author: "Neha Kushwaha",
    excerpt: "",
    image: BehavioralAnalytics,
    slug: "behavioral-analytics",
  },
  {
    id: 17,
    title: "Navigating Marketing Chaos in Sports Retail Marketing",
    category: "Blogs",
    date: "",
    author: "Altaf Mulla",
    excerpt: "",
    image: marketingChaosMin,
    slug: "navigation-marketing-chaos",
  },
  {
    id: 18,
    title:
      "Reading Between the Clicks – The Untold Narratives of Website Visitors",
    category: "Analytics",
    date: "",
    author: "Neeraj Gogavale",
    excerpt: "",
    image: WebsiteVisitors,
    slug: "reading-between-clicks",
  },
  {
    id: 19,
    title: "Harnessing the Decoy Dynamics for Marketing Success",
    category: "Blogs",
    date: "",
    author: "Vrushali Paralkar",
    excerpt: "",
    image: decoyPicMin,
    slug: "decoy-dynamics",
  },

  {
    id: 20,
    title:
      "Distilled Insights from Our Martech Journey: Key Takeaways from our Top-Performing Campaigns",
    category: "Blogs",
    date: "",
    author: "Karan Mudliar",
    excerpt: "",
    image: ExtractingWisdom,
    slug: "extracting-wisdom",
  },
  {
    id: 21,
    title:
      "The Digital Twin Revolution: Reshaping Customer Experience with the Digital Doppelgänger",
    category: "Blogs",
    date: "",
    author: "Vrushali Paralkar",
    excerpt: "",
    image: digitalTwins,
    slug: "the-digital-twin-revolution",
  },
  {
    id: 22,
    title: "5 Key Factors to Consider for E-Commerce Success",
    category: "Blogs",
    date: "",
    author: "Sushant Pingle",
    excerpt: "",
    image: Ecommerence,
  },
  {
    id: 23,
    title:
      "Is it worth investing in a readymade library of Key Performance Indicators to gauge business performance?",
    category: "Analytics",
    date: "",
    author: "Akanksha Jadhav",
    excerpt: "",
    image: KPILibrary,
    slug: "is-it-worth-investing-in-a-readymade-library-of-key-performance-indicators-to-gauge-business-performance",
  },
  {
    id: 24,
    title: "The Pulse of Customer Engagement",
    category: "Blogs",
    date: "",
    author: "Abhishek Deshpande",
    excerpt: "",
    image: customerSignals,
    slug: "the-pulse-of-customer-engagement",
  },
  {
    id: 25,
    title: "Identity Resolution: Your North Star for Customer Contentment",
    category: "Blogs",
    date: "",
    author: "Vishnu Kamath",
    excerpt: "",
    image: IDENTITYRESOLUTION,
    slug: "identity-resolution-your-north-star-for-customer-contentment",
  },
  {
    id: 26,
    title: "Alchemy in the Digital Era for Sculpting Tomorrow’s Businesses",
    category: "Blogs",
    date: "October 30, 2023",
    author: "Omkar Dhapte",
    excerpt: "",
    image: DigitalAlchemyMin,
    slug: "alchemy-in-the-digital-era-for-sculpting-tomorrows-businesses",
  },
  {
    id: 27,
    title:
      "Secrets To Delivering An Immersive Customer Experience In The Sports Industry",
    category: "Blogs",
    date: "",
    author: "Altaf Mulla",
    excerpt: "",
    image: SecretsToDeliveringAnImmersiveCustomerExperience,
    slug: "secrets-to-delivering-an-immersive-customer-experience-in-the-sports-industry",
  },
  {
    id: 28,
    title: "In-the-moment Experience in Phygital World",
    category: "Blogs",
    date: "",
    author: "Pranay Pimple",
    excerpt: "",
    image: InTheMomentExperience,
    slug: "in-the-moment-experience-in-phygital-world",
  },
  {
    id: 29,
    title: "Game-changing Innovations in Retail CX",
    category: "Blogs",
    date: "",
    author: "Neha Kushwaha",
    excerpt: "",
    image: GameChangingInnovationsInRetailCX,
    slug: "game-changing-innovations-in-retail-cx",
  },
  {
    id: 30,
    title:
      "Why Consolidating Traditional & Digital Commerce is Crucial to Omnichannel Agility and Viability for Marketers?",
    category: "Blogs",
    date: "",
    author: "Vaishnavi Patki",
    excerpt: "",
    image: WhyConsolidating,
    slug: "why-consolidating-traditional-and-digital-commerce-is-crucial-to-omnichannel-agility-and-viability-for-marketers",
  },
  {
    id: 31,
    title: "Top Hacks To Hook Customers And Foster Brand Loyalty",
    category: "Blogs",
    date: "",
    author: "Altaf Mulla",
    excerpt: "",
    image: TopHacksToHookCustomers,
    slug: "top-hacks-to-hook-customers-and-foster-brand-loyalty",
  },
  {
    id: 32,
    title:
      "Sustaining The Paradox of Alternatives – The Dire Trend In Customer Behaviour",
    category: "Blogs",
    date: "",
    author: "Shruti Mishra",
    excerpt: "",
    image: SustainingParadox,
    slug: "sustaining-the-paradox-of-alternatives-the-dire-trend-in-customer-behaviour",
  },
  {
    id: 33,
    title: "Strategizing and Building Scalable MarTech Campaigns",
    category: "Blogs",
    date: "",
    author: "Karan Mudliar",
    excerpt: "",
    image: mtech,
    slug: "strategizing-and-building-scalable-martech-campaigns",
  },
  {
    id: 34,
    title: "No More Open Rate As An Email Marketing KPI",
    category: "Blogs",
    date: "",
    author: "Sushant Pingle",
    excerpt: "",
    image: emailMarketing,
    slug: "no-more-open-rate-as-an-email-marketing-kpi",
  },
  {
    id: 35,
    title: "Life in a cookie-less world",
    category: "Blogs",
    date: "",
    author: "Neha Kushwaha",
    excerpt: "",
    image: CookielessWorld,
    slug: "life-in-a-cookie-less-world",
  },
  {
    id: 36,
    title:
      "Integrated Experience (IX) is the Future of Customer Experience (CX)",
    category: "Blogs",
    date: "",
    author: "Vrushali Paralkar",
    excerpt: "",
    image: IntegratedExperience,
    slug: "integrated-experience-ix-is-the-future-of-customer-experience-cx",
  },
  {
    id: 37,
    title:
      "How Self-Service BI Capabilities Improve Harnessing Insights from Massive Data",
    category: "Analytics",
    date: "",
    author: "Vishnu Kamath",
    excerpt: "",
    image: bi,
    slug: "how-self-service-bi-capabilities-improve-harnessing-insights-from-massive-data",
  },
  {
    id: 38,
    title: "Biggest Data Science Challenges of 2023 and How to Overcome Them",
    category: "Analytics",
    date: "",
    author: "Amit Lalwani",
    excerpt: "",
    image: BiggestDataScienceChallenges,
    slug: "biggest-data-science-challenges-of-2023-and-how-to-overcome-them",
  },
  {
    id: 39,
    title: "Importance of Data Democratisation for Marketing Success",
    category: "Blogs",
    date: "",
    author: "Omkar Dhapte",
    excerpt: "",
    image: datadocument,
    slug: "importance-of-data-democratisation-for-marketing-success",
  },
  {
    id: 40,
    title: "Power of Data-driven Segments in the Footwear Industry",
    category: "Blogs",
    date: "",
    author: "Vishnu Kamath",
    excerpt: "",
    image: shooIndustries,
    slug: "power-of-data-driven-segments-in-the-footwear-industry",
  },
  {
    id: 41,
    title: "BI Dashboard Design Principles and Best Practices",
    category: "Analytics",
    date: "",
    author: "Prajakta Patil",
    excerpt: "",
    image: BIDashboardDesignPrinciples,
    slug: "bi-dashboard-design-principles-and-best-practices",
  },

  {
    id: 42,
    title:
      "How to Scale and Grow Your E-commerce Business with Data Engineering",
    category: "Blogs",
    date: "",
    author: "Vishnu Kamath",
    excerpt: "",
    image: EcommerceBusinessWithDataEngineering,
    slug: "how-to-scale-and-grow-your-e-commerce-business-with-data-engineering",
  },
  {
    id: 43,
    title: "How Digital Ecosystems are Reshaping Businesses",
    category: "Blogs",
    date: "",
    author: "Abhishek Deshpande",
    excerpt: "",
    image: DigitalEcosystems,
    slug: "how-digital-ecosystems-are-reshaping-businesses",
  },
  {
    id: 44,
    title: "The Cost of Poor-quality Data",
    category: "Blogs",
    date: "",
    author: "Sushant Pingle",
    excerpt: "",
    image: MicrosoftTeams,
    slug: "the-cost-of-poor-quality-data",
  },

  {
    id: 45,
    title: "AI To Predict Interactivity In Campaigns",
    category: "Blogs",
    date: "",
    author: "Neeraj Gogavale",
    excerpt: "",
    image: machinLearning,
    slug: "ai-to-predict-interactivity-in-campaigns",
  },

  {
    id: 46,
    title: "Express Preparation for PL-300: Microsoft Power BI Data Analyst",
    category: "Blogs",
    date: "",
    author: "Tanvi Chourasia",
    excerpt: "",
    image: tanviBlog,
    slug: "express-preparation-for-pl-300-microsoft-power-bi-data-analyst",
  },
  {
    id: 47,
    title: "The Marketing Automation SkillSet",
    category: "Blogs",
    date: "",
    author: "Bhakti Shinde",
    excerpt: "",
    image: marketingAutomation,
    slug: "the-marketing-automation-skillset",
  },
  {
    id: 48,
    title: "Embracing Failure to Becoming Successful",
    category: "Blogs",
    date: "",
    author: "Sagar Babar",
    excerpt: "",
    image: SagarBlog,
    slug: "embracing-failure-to-becoming-successful",
  },
  {
    id: 49,
    title:
      "Take your customer’s experience to the next level with Predictive Analytics",
    category: "Blogs",
    date: "",
    author: "Biju Nambiar",
    excerpt: "",
    image: PredictiveAnalytics,
    slug: "take-your-customers-experience-to-the-next-level-with-predictive-analytics",
  },
  {
    id: 50,
    title: "Demystifying Predictive Analytics",
    category: "Blogs",
    date: "",
    author: "Amit Lalwani",
    excerpt: "",
    image: PredictiveAnalytics2,
    slug: "demystifying-predictive-analytics",
  },
  {
    id: 50,
    title:
      "Significance of Data Analysis and its Impact on the Conversion Rates",
    category: "Blogs",
    date: "",
    author: "Vishnu Kamath",
    excerpt: "",
    image: DataAnalysis,
    slug: "significance-of-data-analysis-and-its-impact-on-the-conversion-rates",
  },
  {
    id: 51,
    title: "Key skills for Marketing Automation team",
    category: "Blogs",
    date: "",
    author: "Bhakti Shinde",
    excerpt: "",
    image: BlogCaree,
    slug: "key-skills-for-marketing-automation-team",
  },
  {
    id: 52,
    title: "Is your marketing and customer on same page",
    category: "Blogs",
    date: "",
    author: "Aniket Neurgoankar",
    excerpt: "",
    image: marketingAndCustomer,
    slug: "is-your-marketing-and-customer-on-same-page",
  },
  {
    id: 53,
    title: "8 Reasons Why Marketing Automation is the new career",
    category: "Blogs",
    date: "",
    author: "Karan Mudliar",
    excerpt: "",
    image: BlogCareers,
    slug: "8-reasons-why-marketing-automation-is-the-new-career",
  },
  {
    id: 54,
    title: "IBM Beacon Award Finalist 2021",
    category: "Blogs",
    date: "",
    author: "Vineet Ladhania",
    excerpt: "",
    image: VineetPhoto,
    slug: "ibm-beacon-award-finalist-2021",
  },
  {
    id: 55,
    title: "Developing The NextGen Leaders In Our Unique Way",
    category: "Blogs",
    date: "",
    author: "Comsense Tech",
    excerpt: "",
    image: empCollage,
    slug: "developing-the-nextgen-leaders-in-our-unique-way",
  },
];
